import './live_styles.scss'

import 'babel-polyfill'
import 'bootstrap/dist/js/bootstrap';
import Rails from 'rails-ujs';
import Vue from 'vue/dist/vue.esm.js'
import BootstrapVue from 'bootstrap-vue'
import ActionCableVue from 'actioncable-vue'
import VueI18n from 'vue-i18n'
import { messages } from '../src/i18n.js'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.config.productionTip = false
Rails.start()
Vue.use(BootstrapVue)

currentOriginCableUrl = ->
  if typeof window != 'undefined' and window.location?
    protocol = if window.location.protocol == 'https:' then 'wss:' else 'ws:'
    "#{protocol}//#{window.location.host}/cable"
  else
    process.env.CABLE_URL

metaCableUrl = ->
  if typeof document != 'undefined'
    element = document.head.querySelector("meta[name='action-cable-url']")
    element?.getAttribute('content')
  else
    null

cableConnectionUrl = ->
  metaCableUrl() || currentOriginCableUrl() || process.env.CABLE_URL

Vue.use(ActionCableVue, {
  debug: false,
  debugLevel: 'all',
  connectionUrl: cableConnectionUrl()
})
Vue.use(VueI18n)

Vue.use(VueAxios, axios)
Vue.axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
Vue.axios.defaults.headers.common['Accept'] = 'application/json'
Vue.axios.defaults.headers.common['Content-Type'] = 'application/json'
Vue.axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate'


import DateTime from '../src/admin/components/datetime'
import EventStats from '../src/front/components/event-stats'
import LiveCheckin from '../src/front/components/live-checkin'
import LiveFinish from '../src/front/components/live-finish'
import LiveFinishOneline from '../src/front/components/live-finish-oneline'
import LiveResults from '../src/front/components/live-results'
import TimingBoard from '../src/front/components/timing-board'

$ ->
  window.i18n = new VueI18n(locale: general.locale, messages: messages)

  element = document.getElementById('app')
  if element
    window.app = new Vue
      el: element
      i18n: i18n
      components: {DateTime, LiveCheckin, LiveFinish, LiveFinishOneline, LiveResults, EventStats, TimingBoard}
      data: ->
        heats: general.heats || []
        race: general.race || {}
        update: {heats: false}
        extra: general.extra || {}
